import SubNavMenuRecordName from './SubNavMenuRecordName'

export default SubNavMenuRecordName
